import type { ApiRoute, NoBody, NoPathParams } from "../api"
import type { InventoryListSettings } from "./InventoryListSettings"
import type { InventoryListView } from "./InventoryListView"

export interface InventoryListViewQueryParams extends InventoryListSettings {
	limit: string
	offset: string
}

export const getInventoryListViewRoute: ApiRoute<
	NoPathParams,
	InventoryListViewQueryParams,
	NoBody,
	InventoryListView
> = {
	buildUrl: () => "/inventory",
	method: "get",
	path: "/inventory",
}
